export default [
    /**
     * Roles and permissions are managed in Dash now. Their old pages lead
     * here, to say so.
     */
    {
        path: '/users/roles-and-permissions',
        alias: [
            '/users/groups/list',
            '/users/groups/create',
            '/users/groups/edit/:id',
            '/users/permissions/list',
            '/users/permissions/create',
            '/users/permissions/edit/:id',
        ],
        name: 'RolesAndPermissions_ManagedInDash',
        component: () => import('@/views/user/ManagedInDash.vue'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/users/create',
        name: 'Users_Create',
        component: () => import('@/views/user/create.vue'),
        meta: {
            authRequired: true,
            permission: 'Administrator'
        }
    },
    {
        path: '/users/list',
        name: 'Users_List',
        component: () => import('@/views/user/list.vue'),
        meta: {
            authRequired: true,
            permission: 'Administrator'
        }
    },
    {
        path: '/users/edit/:id',
        name: 'Users_Update',
        component: () => import('@/views/user/edit.vue'),
        meta: {
            authRequired: true,
            permission: 'Administrator'
        }
    },
    {
        path: '/users/change-pass',
        name: 'Force_Change_Pass',
        component: () => import('@/views/pages/authentication/ResetPassword.vue'),
        meta: {
            layout: 'full',
            authRequired: true
        }
    },

    {
        path: '/user/organization/create',
        name: 'Organization_Unit_Create',
        component: () => import('@/views/user/organization/create.vue'),
        meta: {
            authRequired: true,
            permission: 'organizations.store'
        }
    },
    {
        path: '/user/organization/list',
        name: 'Organization_Unit_List',
        component: () => import('@/views/user/organization/list.vue'),
        meta: {
            authRequired: true,
            permission: 'organizations.index'
        }
    },
    {
        path: '/user/organization/edit/:id',
        name: 'Organization_Unit_Update',
        component: () => import('@/views/user/organization/edit.vue'),
        meta: {
            authRequired: true,
            permission: 'organizations.update',
            navActiveLink:'Organization_Unit_List'
        }
    },
    {
        path: '/users/login-logs',
        name: 'Users_login_logs',
        component: () => import('@/views/user/logs.vue'),
        meta: {
            authRequired: true,
        }
    },

]
